// Label-first warehouse shopify_location_ids (Tinton Falls + Eatontown across
// all six stores). Must match backend database.LABEL_FIRST_WAREHOUSE_LOC_IDS
// verbatim. See docs/superpowers/specs/2026-08-05-tinton-eatontown-warehouse-workflow-design.md
// for the full spec.
//
// At these locations, printing the shipping label does NOT imply that items
// have been physically picked/pressed/packed. Frontend badges must NOT
// inflate portalState from the shipped-FO invariant at these locs — the
// picker's real scans are the sole authority.
export const LABEL_FIRST_WAREHOUSE_LOC_IDS = new Set([
    // Tinton Falls (6)
    '81277419698',    // soccerpost
    '110248427884',   // citysports
    '80306438334',    // u90
    '86007939325',    // b2b
    '97551581461',    // stefans
    '108354502967',   // surf
    // Eatontown (6)
    '62741479602',    // soccerpost
    '63057854623',    // citysports
    '62808719550',    // u90
    '68248895741',    // b2b
    '95045353749',    // stefans
    '77554385207',    // surf
]);

export function isLabelFirstWarehouse(locId) {
    if (locId === null || locId === undefined || locId === '') return false;
    return LABEL_FIRST_WAREHOUSE_LOC_IDS.has(String(locId));
}
